<template>
  <div
    class="flex flex-direction-column justify-content-center align-items-center"
    :style="{ transform: `scale(${scaleRate})` }"
  >
    <img class="img" src="@/assets/common/no-data.png" alt="" :style="`width: ${width}px;height: ${height}px`" />
    <div :class="titleClass">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    scaleRate: {
      type: Number,
      default: () => 1
    },
    width: {
      type: Number,
      default: () => 400
    },
    height: {
      type: Number,
      default: () => 232
    },
    title: {
      type: String,
      default: () => '暂无更多'
    },
    titleClass: {
      type: String,
      default: () => 'fs14 c999'
    }
  }
}
</script>

<style lang="scss" scoped>
.img {
  width: 120px;
  height: auto;
}
</style>
